module.exports = __webpack_public_path__ + "img/PK_Asset_Info_Web4.dfc9d791.png";